import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface ChatGenerationError {
    message: string;
    statusCode?: number;
    code?: string;
}

interface ChatErrorsState {
    // Локальные ошибки запуска генерации (по messageId).
    // Используются когда startGeneration упал ДО создания job на бэке —
    // job в БД нет, поэтому ошибку показывает фронт из памяти.
    // Persist'им в localStorage, чтобы после F5 пользователь по-прежнему
    // видел маркер «генерация не запустилась» и кнопку Retry.
    errors: Record<string, ChatGenerationError>;
    setError: (messageId: string, error: ChatGenerationError) => void;
    clearError: (messageId: string) => void;
}

export const useChatErrorsStore = create<ChatErrorsState>()(
    persist(
        (set) => ({
            errors: {},
            setError: (messageId, error) => set((s) => ({ errors: { ...s.errors, [messageId]: error } })),
            clearError: (messageId) =>
                set((s) => {
                    if (!(messageId in s.errors)) return s;
                    const next = { ...s.errors };
                    delete next[messageId];
                    return { errors: next };
                }),
        }),
        {
            name: "chat-errors",
            version: 2,
            migrate: (persisted) => {
                if (!persisted || typeof persisted !== "object") {
                    return { errors: {} };
                }
                const prev = persisted as { errors?: Record<string, ChatGenerationError> };
                return { errors: prev.errors ?? {} };
            },
        },
    ),
);

export function useChatMessageError(messageId: string): ChatGenerationError | null {
    return useChatErrorsStore((s) => s.errors[messageId] ?? null);
}
